import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { cloneElement, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const ButtonGroup = ({ children, className = '', }) => (_jsx(ClassNames, { children: ({ css, cx, }) => {
        const group = css `
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: flex-end;
        column-gap: ${theme.spacing.x3};
        row-gap: ${theme.spacing.x3};
        ${theme.media.greaterThan('small') `
          flex-direction: row;
        `}
      `;
        const primaryStyles = css `
        margin-bottom: ${styleUtils.rem(10)};
        ${theme.media.greaterThan('small') `
          order: 2;
          margin-left: ${styleUtils.rem(10)};
          margin-bottom: 0;
        `}
      `;
        return (_jsxs("div", Object.assign({ className: className, css: group }, { children: [cloneElement(children[0], {
                    className: cx(children[0].props.className, primaryStyles),
                    expandedAt: 'small',
                }), cloneElement(children[1], {
                    className: cx(children[1].props.className, css `
                      ${theme.media.greaterThan('small') `order:1;`}
                    `),
                    expandedAt: 'small',
                })] })));
    } }));
const MemoizedButtonGroup = memo(ButtonGroup);
export { MemoizedButtonGroup as ButtonGroup };
// MC-1068 Temporary hack for Storybook.
export default ButtonGroup;
